import {createStore} from 'zustand/vanilla';
import type {SidebarPanel} from '#types/journeys.js';
import type {Nullable} from '#types/general.js';

export type JourneyPanel = {
  open: boolean;
  selectedPanel: Nullable<SidebarPanel>;
};

export type JourneyUIState = {
  journeyPanel: JourneyPanel;
  setJourneyPanel: (panel: JourneyPanel) => void;
};

export const uiStore = createStore<JourneyUIState>()(set => ({
  journeyPanel: {
    open: false,
    selectedPanel: null,
  },

  setJourneyPanel(panel: JourneyPanel) {
    set(state => ({
      ...state,
      journeyPanel: {
        ...state.journeyPanel,
        ...panel,
      },
    }));
  },
}));
